module.exports = __webpack_public_path__ + "img/MULTPEX_VETOR.0680c928.png";